/**
 *  Formats an address object into a string
 * @deprecated use formatServiceAddress instead
 * @param address
 * @param withBreaks
 * @returns  formatted address string
 */
export const buildAddressString = (address, withBreaks) => {
    if (!address)
        return '';
    if (withBreaks) {
        return `${address.addressLine1 + (address.addressLine2 ? `, ${address.addressLine2}` : '')},\n${address.city}, ${address.state} ${address.zip}`;
    }
    return `${address.addressLine1 + (address.addressLine2 ? `, ${address.addressLine2}` : '')}, ${address.city}, ${address.state} ${address.zip}`;
};
/**
 *  Formats Service Address String
 * @param address
 * @param withBreaks
 * @param undefinedValue if there is no address, replaces Unknown with customer text
 * @returns  formatted address string
 */
export const formatServiceAddress = (address, options) => {
    if (typeof address === 'string') {
        return address;
    }
    if (!address || (!address.addressLine1 && !address.addressLine2 && !address.city && !address.state && !address.zip))
        return options?.undefinedValue ?? 'Unknown';
    if (!address)
        return '';
    if (options?.partial) {
        return `${(address.addressLine1 || '') + (address.addressLine2 ? `, ${address.addressLine2}` : '')}${address.addressLine1 ? ', ' : ''}${address.city || ''}, ${address.state || ''} ${address.zip || ''}`;
    }
    if (options?.withBreaks) {
        return `${address.addressLine1 + (address.addressLine2 ? `, ${address.addressLine2}` : '')},\n${address.city}, ${address.state} ${address.zip}`;
    }
    if (options?.withCountry) {
        return `${address.addressLine1 + (address.addressLine2 ? `, ${address.addressLine2}` : '')}${address.addressLine1 ? ', ' : ''}${address.city}, ${address.state} ${address.zip} ${address.country}`;
    }
    return `${address.addressLine1 + (address.addressLine2 ? `, ${address.addressLine2}` : '')}${address.addressLine1 && ', '}${address.city}, ${address.state} ${address.zip}`;
};
//# sourceMappingURL=address-formatter.js.map